<template>
  <div class="mockup-preview-image">
    <slot name="stores"></slot>

    <div class="mockup__input">
      <label class="mockup__btn" :for="`previewImage${timestamp}`"
        >Upload Image</label
      >
      <input
        type="file"
        v-show="false"
        :id="`previewImage${timestamp}`"
        ref="previewImage"
        @change="setPreviewImage"
        accept=".png, .jpg, .jpeg"
      />
    </div>
    <preview-image :current="current.previewImage" />
  </div>
</template>

<script>
import PreviewImage from "./preview-image/PreviewImage.vue";

export default {
  components: {
    PreviewImage,
  },
  props: {
    current: Object,
  },
  data() {
    return {
      timestamp: new Date().getTime(),
    };
  },
  methods: {
    setPreviewImage() {
      const file = this.$refs.previewImage.files[0];
      if (!file) return;
      const _URL = window.URL || window.webkitURL;
      const i = new Image();
      i.onload = () => {
        if (i.width === i.height) this.current.addPreviewImage({ file });
        else
          alert(
            "Só trabalhamos com imagens quadradas para as estáticas, tente novamente!"
          );
      };
      i.src = _URL.createObjectURL(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.mockup-preview-image {
  display: grid;
  padding: 0 6px 6px;
  gap: 6px;
}
</style>
